module.exports = __webpack_public_path__ + "static/img/vEight5.80f8b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vEight5.png
// module id = rFpl
// module chunks = 2